// test881
(881 && 0);
